import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper/modules';
import './style/section5.css';

const Section5 = () => {
  const testimonials = [
    {
      name: 'Jessica Brown',
      role: 'Customer',
      image: 'https://images.pexels.com/photos/3765163/pexels-photo-3765163.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
      text: 'This is due to their excellent service, competitive pricing and customer support. It’s thoroughly refreshing to get such a personal touch. Duis aute lorem ipsum is simply free text irure dolor in reprehenderit in esse nulla pariatur.'
    },
    {
      name: 'Caleb Hoffman',
      role: 'Customer',
      image: 'https://images.pexels.com/photos/3168991/pexels-photo-3168991.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load',
      text: 'This is due to their excellent service, competitive pricing and customer support. It’s thoroughly refreshing to get such a personal touch. Duis aute lorem ipsum is simply free text irure dolor in reprehenderit in esse nulla pariatur.'
    },
    {
      name: 'Bradley Kim',
      role: 'Customer',
      image: 'https://images.pexels.com/photos/2956690/pexels-photo-2956690.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load',
      text: 'This is due to their excellent service, competitive pricing and customer support. It’s thoroughly refreshing to get such a personal touch. Duis aute lorem ipsum is simply free text irure dolor in reprehenderit in esse nulla pariatur.'
    },
  ];

  return (
    <div style={{ width: '70%', margin: '56px auto', position: 'relative' }} className='h-full md:h-96 w-28'>
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          dynamicBullets: true,
        }}
        navigation={false}
        className="mySwiper"
      >
        {testimonials.map((testimonial, index) => (
          <SwiperSlide key={index} className='py-10'>
            <div>
              <div className='flex justify-center items-center'>
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="h-20 w-20 object-cover rounded-full"
                />
                <div className='m-5'>
                  <p>{testimonial.name}</p>
                  <p>{testimonial.role}</p>
                </div>
              </div>
              <div>
                <p className='text-center my-10 text-lg font-medium text-gray-700'>
                  {testimonial.text}
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default Section5;
